/**
 * Helpers for routine-scoped job arguments (SCRUM-625) — a JSON object
 * string stored on the routine and merged into every job's arguments as
 * `variable_schema defaults < routine.arguments < per-run operator args`.
 */
export class RoutineArgumentsUtils {
  /**
   * Parse a stored arguments string.
   * Returns undefined for absent/empty/`"{}"`/malformed/non-object values
   * (the server-side merge ignores those too).
   */
  static parse(raw: string | null | undefined): Record<string, unknown> | undefined {
    const trimmed = (raw ?? '').trim();
    if (!trimmed || trimmed === '{}') {
      return undefined;
    }
    try {
      const parsed = JSON.parse(trimmed);
      if (
        parsed &&
        typeof parsed === 'object' &&
        !Array.isArray(parsed) &&
        Object.keys(parsed).length > 0
      ) {
        return parsed as Record<string, unknown>;
      }
    } catch {
      // Malformed stored arguments — treat as absent.
    }
    return undefined;
  }

  /** Pretty-printed stored arguments for display; empty string when absent. */
  static pretty(raw: string | null | undefined): string {
    const parsed = RoutineArgumentsUtils.parse(raw);
    return parsed ? JSON.stringify(parsed, null, 2) : '';
  }
}
